export { default as tr } from "./tr";
export { default as en } from "./en";
export { default as fr } from "./fr";
export { default as es } from "./es";
export type { TranslationKeys } from "./tr";

export const SUPPORTED_LANGUAGES = [
  { code: "tr", label: "Türkçe" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]["code"];
